import AbstractProductType from './AbstractProductType'
import type { VSelectItem } from '../types/vuetify'

class ProductTypeRegistry {

  #productTypes: {[key: string]: AbstractProductType} = {}

  /**
   * Add a product type to the registry.
   */
  register(productType: AbstractProductType) {
    this.#productTypes[productType.name] = productType
  }

  /**
   * Retrive a registered product type by name.
   */
  get(name: string): AbstractProductType | undefined {
    return this.#productTypes[name] ?? null
  }

  getTitle(name: string): string | undefined {
    return this.#productTypes[name]?.title ?? name
  }

  getOptions(): VSelectItem[] {
    return this.getOptionsAsObjects()
      .map((productType: AbstractProductType): VSelectItem => {
        return {value: productType.name, title: productType.title}
      })
  }

  getOptionsAsObjects(): AbstractProductType[] {
    return Object.values(this.#productTypes)
  }

}

export default new ProductTypeRegistry()
